import { selectIsInternalAdmin } from 'accessors'
import moment from 'moment'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { deleteExclusion } from '../../../actions/hotelDetails'
import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog/index'
import {
  behaviorNames,
  hotelDetailsBlacklistCategories as catNames
} from '../../../main/blacklistHelpers'
import { lowercaseFirstLetter } from '../../../utils/helpers'
import Box from '../Box/index'
import { ReactComponent as DeleteIcon } from './delete.svg'
import styles from './Exclusions.module.scss'

const Exclusions = ({ data, title, handleReload }) => {
  const dispatch = useDispatch()
  const [showConfirmation, setShowConfirmation] = useState()
  const [nameOfExclusionToBeDeleted, setNameOfExclusionToBeDeleted] = useState()
  const [IdOfExclusionToBeDeleted, setIdOfExclusionToBeDeleted] = useState()

  function handleDelete(name, id) {
    setShowConfirmation(true)
    setIdOfExclusionToBeDeleted(id)
    setNameOfExclusionToBeDeleted(name)
  }

  function handleConfirmDelete() {
    dispatch(deleteExclusion(IdOfExclusionToBeDeleted))
    setShowConfirmation(false)
    handleReload()
  }

  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  const [isCollapsed, setCollapsed] = useState(isInternalAdmin)

  return (
    <Box
      className={styles.exclusions}
      title={title}
      isCollapsed={data.length ? isCollapsed : null}
      handleClick={() => setCollapsed(!isCollapsed)}
    >
      {showConfirmation && (
        <ConfirmationDialog
          title="Are you sure you want to delete this?"
          hasDangerousAction
          positiveMessage="Yes"
          negativeMessage="No, cancel"
          onConfirm={handleConfirmDelete}
          onClose={() => setShowConfirmation(false)}
          onPressEnter={handleConfirmDelete}
        >
          <div>
            Exclusion with <b>{nameOfExclusionToBeDeleted}</b> rule will be removed.
          </div>
        </ConfirmationDialog>
      )}
      {data.length ? (
        <>
          {isCollapsed ? (
            <div className={styles.seeMoreLink}>See {data.length} exclusions</div>
          ) : (
            data.map(e => (
              <Exclusion {...e} key={e.exclusionId} handleDelete={handleDelete} />
            ))
          )}
        </>
      ) : (
        'No exclusions'
      )}
    </Box>
  )
}

const Exclusion = ({
  category,
  behavior,
  itemValue,
  updatedOn,
  exclusionId,
  handleDelete
}) => {
  const name = `${catNames[lowercaseFirstLetter(category)] || category}  ${itemValue}`

  return (
    <div className={styles.exclusion}>
      <div>
        <p className={styles.title}>{name}</p>
        <p className={styles.details}>
          {getBlacklistBehavior(behavior) || 'Unknown behavior'}, updated on{' '}
          {moment(updatedOn).format('MMM D')}
        </p>
      </div>
      <button onClick={() => handleDelete(name, exclusionId)}>
        <DeleteIcon />
      </button>
    </div>
  )
}
function getBlacklistBehavior(str) {
  return behaviorNames[str.charAt(0).toLowerCase() + str.slice(1)]
}

export default Exclusions
